import { DataAction, HeaderState, SnackbarState } from '@/store/types'
import { SET_HEADER, SET_SNACKBAR, SET_SNACKBAR_SHOWING } from './mutation-types'
import { RootState } from './types'

const setSnackbar: DataAction<RootState, SnackbarState> = (
  { commit },
  { type, message, timeout = 2000, clearable },
) => {
  commit(SET_SNACKBAR, { type, message, timeout, clearable })
  commit(SET_SNACKBAR_SHOWING, true)

  setTimeout(() => {
    commit(SET_SNACKBAR_SHOWING, false)
  }, timeout)
}

const setHeader: DataAction<RootState, HeaderState> = ({ commit }, header) => {
  commit(SET_HEADER, header)
}

export default {
  setSnackbar,
  setHeader,
}
